import jquery from 'jquery';
import _Singleton from '@/tools/singleton';

import options from '@/ui/ui_trigger-events/default-selectors.json';

/**
 * @class
 * @private
 *
 * @description
 * DOM + triggerEvents
 */
var triggerEventsDOM = function() {
  var self = this;

  document.addEventListener('DOMContentLoaded', function(event) {
    self._init();
  });
};

/**
 * Инициализация
 * @method
 * @private
 */
triggerEventsDOM.prototype._init = function() {
  var self = this;

  self.options = options;

  self._bindTriggerClick();
};

/**
 * Обработчик для события Click
 * @method
 * @private
 */
triggerEventsDOM.prototype._bindTriggerClick = function() {
  var self = this;

  jquery(document).on('click', self.options.eventClick.attr, function(event) {
    var event_name = jquery(this).data(self.options.eventClick.data);
    var event_data = { event_target: jquery(this)[0] };

    EventBus.publish(event_name, event_data);
  });
};

export default _Singleton(triggerEventsDOM).getInstance();
